import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User, UserRoleService } from '../services/role.service';

@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    constructor(
        private userRoleService: UserRoleService,
        private router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const allowedRoles = route.data['allowedRoles'] as string[] | undefined;

        return this.userRoleService.getCurrentUser().pipe(
            map((user: User | null) => {
                if (!user) {
                    console.warn('User data is null in role guard');
                    return this.router.parseUrl('/logout');
                }
                const userRole = this.userRoleService.getHighestRole(user);
                const userRoles = this.userRoleService.getNormalizedRoles(user);
                const normalizedAllowedRoles = allowedRoles?.map((role) => role.toLowerCase()) ?? [];

                if (!normalizedAllowedRoles.length || userRoles.some((role) => normalizedAllowedRoles.includes(role))) {
                    return true;
                }

                if (userRole === 'superadmin') {
                    return this.router.parseUrl('/center-management');
                } else if (userRole === 'groupadmin') {
                    return this.router.parseUrl('/home');
                } else if (userRole === 'centeradmin') {
                    return this.router.parseUrl('/home');
                } else if (userRole === 'centeruser') {
                    return this.router.parseUrl('/calendar');
                } else {
                    return this.router.parseUrl('/home');
                }
            }),
            catchError((error) => {
                console.error('Error in role guard:', error);
                return of(this.router.parseUrl('/'));
            })
        );
    }
}
